import { Component, computed, inject, signal } from '@angular/core';
import { CustomValidators } from '../../utilities/customer_validators';
import { CommonFormComponent, FormField } from '../../components/common-form/common-form';
import { I18nService } from '../../services/i18n.service';
import { AuthenticationService } from '../../services/authentication.service';
import { UtilService } from '../../services/util.service';
import { Router } from '@angular/router';
import { NavButtonComponent } from '../../components/nav-button/nav-button';
import { FormKey } from '../../enums/i18.enum';
import { UiService } from '../../services/ui.service';
import { Validators } from '@angular/forms';
import { LP_UI_CONFIG } from '../../core/tokens';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';

@Component({
  selector: 'app-forget-password',
  imports: [CommonFormComponent, NavButtonComponent],
  templateUrl: './forget-password.html',
  styleUrl: './forget-password.scss',
})
export class ForgetPassword {
  public forgetPasswordForm = new CommonFormComponent();
  i18n = inject(I18nService);
  auth = inject(AuthenticationService);
  util = inject(UtilService);
  router = inject(Router);
  public ui = inject(UiService);
  public readonly cfg = inject(LP_UI_CONFIG);
  isMobile = computed(() => this.ui.IsMobile());
  formConfiguration: FormField[] = [
    {
      controlName: FormKey.Email,
      label: FormKey.LabelEmail,
      controlType: FormKey.Text,
      placeholder: FormKey.EmailPlaceholder,
      initialValue: FormKey.Empty,
      validators: [...CustomValidators.email],
    },
    {
      controlName: FormKey.CaptchaResponse,
      label: this.cfg.enableCaptcha ? FormKey.Captcha : GLOBAL_CONSTANT.EMPTY_STRING,
      controlType: FormKey.Captcha,
      placeholder: '',
      initialValue: null,
      validators: this.cfg.enableCaptcha ? [Validators.required] : [],
    },
  ];
  hasSendPWForgotMail = signal(false);
  sendMailError = false;

  forgetPassword(formData: any) {
    if (this.cfg.enableCaptcha && formData.captchaResponse) {
      this.auth.requestForgotPasswordMail(formData.email, formData.captchaResponse).subscribe(
        () => {
          this.hasSendPWForgotMail.set(true);
        },
        (error) => {
          if (error.status === 401) {
            this.util.setLoadingFinished();
            this.hasSendPWForgotMail.set(false);
          } else this.sendMailError = true;
          console.error(error);
          setTimeout(() => this.util.setLoadingFinished(), 1000);
        }
      );
    } else {
      this.auth.requestForgotPasswordMail(formData.email).subscribe(
        () => {
          this.hasSendPWForgotMail.set(true);
        },
        (error) => {
          if (error.status === 401) {
            this.util.setLoadingFinished();
            this.hasSendPWForgotMail.set(false);
          } else this.sendMailError = true;
          console.error(error);
          setTimeout(() => this.util.setLoadingFinished(), 1000);
        }
      );
    }
  }

  toLoginPage() {
    this.router.navigate(['/login']);
  }

  PWForgotMailNotReceived() {
    this.hasSendPWForgotMail.set(false);
  }
}
